import React, { FC, ReactElement, useState, useEffect } from 'react';
import { toggleLanguage, internalizationState } from '../../../../stores/reducers/sections';
import { getEventKey } from '../../../../stores/reducers/userData';
import { useDispatch, useSelector } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';
import cns from 'classnames';
import en from '../../../../assets/img/en.png';
import ru from '../../../../assets/img/ru.png';
import './lang.switter.sass';

interface Prop {
  type: string;
}

interface ILangTemplate {
  key: string;
  label: string;
  icon: string;
}

interface ILangTemplates {
  en: ILangTemplate;
  ru: ILangTemplate;
}

const LanguageSwitcher: FC<Prop> = ({ type }): ReactElement => {
  const langConfig = useSelector(internalizationState);
  const dispatch = useDispatch();
  const eventKey = useSelector(getEventKey);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [activeLang, setActiveLang] = useState<ILangTemplate>();

  const langTemplates: ILangTemplates = {
    en: {
      key: 'en',
      label: 'English',
      icon: en
    },
    ru: {
      key: 'ru',
      label: 'Russian',
      icon: ru
    },
  };

  const initActiveLang = () => {
    setActiveLang(langTemplates[langConfig.activeLangState as keyof ILangTemplates])
  };

  useEffect(initActiveLang, [langConfig.activeLangState]);

  const switchLang = (lang: string): void => {
    setMenuOpen(false);
    dispatch(toggleLanguage({locale: lang, eventKey}));
  };
  
  return (
    <div className={cns('lang-switcher', type)}>
      <OutsideClickHandler
        onOutsideClick={() => setMenuOpen(false)}
      >
        {
          activeLang &&
          <button
            className="lang-switcher__button dropwdown"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <img src={activeLang.icon} alt="English" />
            <span className="lang-switcher__label">{activeLang.label}</span>
            <span className="lang-switcher__triangle">
              <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M0 0L4 4L8 0H0Z" fill="white"/>
              </svg>
            </span>
          </button>
        }

        {
          menuOpen &&
          <div className="dropdown-lang-list">
            {
              Object.keys(langTemplates).map((key: string) => langConfig.activeLangState !== key && (
                <button
                  className="lang-switcher__button"
                  onClick={() => switchLang(langTemplates[key as keyof ILangTemplates].key)}
                  key={key}
                >
                  <img
                    src={langTemplates[key as keyof ILangTemplates].icon}
                    alt={langTemplates[key as keyof ILangTemplates].label}
                  /> 
                  <span className="lang-switcher__label">{langTemplates[key as keyof ILangTemplates].label}</span>
                  <span className="lang-switcher__triangle">
                    <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M0 0L4 4L8 0H0Z" fill="white"/>
                    </svg>
                  </span>
                </button>
              ))
            }
          </div>
        }
      </OutsideClickHandler>
    </div>
  )
};
  
export default LanguageSwitcher;
